import React from 'react';
import {TextBlock, RectShape} from 'react-placeholder/lib/placeholders';
import {
    SECTION_TYPE_TEXT, SECTION_TYPE_BLOCK, SECTION_TYPE_MAP,
    SECTION_TYPE_PRICE, SECTION_TYPE_FORM, SECTION_TYPE_REVIEWS,
    SECTION_TYPE_ITINERARY, SECTION_TYPE_PARTNERS, SECTION_TYPE_NEXT_STEPS,
    SECTION_TYPE_FAQS, SECTION_TYPE_STAFF_PROFILES, SECTION_TYPE_PRODUCT_SNIPPET,
    SECTION_TYPE_TRIP_FORMAT_SNIPPET, SECTION_TYPE_REVIEW_SNIPPETS, SECTION_TYPE_STAFF
} from '../../constants';

export const getSectionPlaceholderBySectionType = (sectionTypeId) => {
    let placeholder;

    switch(sectionTypeId) {
        case SECTION_TYPE_TEXT:
            placeholder = sectionPlaceholder;
            break;
        case SECTION_TYPE_BLOCK:
            placeholder = sectionBlockPlaceholder;
            break;
        case SECTION_TYPE_MAP:
            placeholder = sectionMapPlaceholder;
            break;
        case SECTION_TYPE_PRICE:
            placeholder = sectionPricesPlaceholder;
            break;
        case SECTION_TYPE_FORM:
        case SECTION_TYPE_PRODUCT_SNIPPET:
        case SECTION_TYPE_TRIP_FORMAT_SNIPPET: 
        case SECTION_TYPE_NEXT_STEPS: 
        case SECTION_TYPE_REVIEW_SNIPPETS:
            placeholder = sectionFormPlaceholder;
            break;
        case SECTION_TYPE_REVIEWS:
        case SECTION_TYPE_FAQS:
            placeholder = sectionReviewsPlaceholder;
            break;
        case SECTION_TYPE_ITINERARY:
            placeholder = sectionItineraryPlaceholder;
            break;
        case SECTION_TYPE_PARTNERS:
        case SECTION_TYPE_STAFF:
        case SECTION_TYPE_STAFF_PROFILES:
            placeholder = sectionPartnersPlaceholder;
            break;
        default:
            placeholder = sectionProjectsPlaceholder;
            break;
    }

    return placeholder;
}

let iconImagePath = process.env.PUBLIC_URL + `/assets/pagebuilder/element-image.svg`;
export const sectionPlaceholder = <div style={{display: 'flex'}}>
        <img alt="Projects Abroad"src={iconImagePath} style={{marginRight: '10px', height: '80px'}}/>
        <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
    </div>;

let iconBlockPath = process.env.PUBLIC_URL + `/assets/pagebuilder/element-2.svg`;
export const sectionBlockPlaceholder = <div style={{display: 'flex'}}>
    <img alt="Projects Abroad"src={iconBlockPath} style={{marginRight: '10px', height: '80px'}}/>
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
</div>;

let iconPricesPath = process.env.PUBLIC_URL + `/assets/pagebuilder/element-4.svg`;
export const sectionPricesPlaceholder = <div style={{display: 'flex'}}>
    <img alt="Projects Abroad"src={iconPricesPath} style={{marginRight: '10px', height: '80px'}}/>
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
</div>;

let iconMapPath = process.env.PUBLIC_URL + `/assets/pagebuilder/element-3.svg`;
export const sectionMapPlaceholder = <div style={{display: 'flex'}}>
    <img alt="Projects Abroad"src={iconMapPath} style={{marginRight: '10px', height: '80px'}}/>
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
</div>;

let iconReviewsPath = process.env.PUBLIC_URL + `/assets/pagebuilder/element-7.svg`;
export const sectionReviewsPlaceholder = <div style={{display: 'flex'}}>
    <img alt="Projects Abroad"src={iconReviewsPath} style={{marginRight: '10px', height: '80px'}}/>
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
</div>;

let iconFormPath = process.env.PUBLIC_URL + `/assets/pagebuilder/element-5.svg`;
export const sectionFormPlaceholder = <div style={{display: 'flex'}}>
    <img alt="Projects Abroad"src={iconFormPath} style={{marginRight: '10px', height: '80px'}}/>
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
</div>;

let iconPartnersPath = process.env.PUBLIC_URL + `/assets/pagebuilder/element-8.svg`;
export const sectionPartnersPlaceholder = <div style={{display: 'flex'}}>
    <img alt="Projects Abroad"src={iconPartnersPath} style={{marginRight: '10px', height: '80px'}}/>
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
</div>;

let iconItineraryPath = process.env.PUBLIC_URL + `/assets/pagebuilder/element-1.svg`;
export const sectionItineraryPlaceholder = <div style={{display: 'flex'}}>
    <img alt="Projects Abroad"src={iconItineraryPath} style={{marginRight: '10px', height: '80px'}}/>
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
</div>;

let iconHtmlPath = process.env.PUBLIC_URL + `/assets/pagebuilder/element-6.svg`;
export const sectionHtmlPlaceholder = <div style={{display: 'flex'}}>
    <img alt="Projects Abroad"src={iconHtmlPath} style={{marginRight: '10px', height: '80px'}}/>
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
</div>;

export const sectionProjectsPlaceholder = <div style={{display: 'flex', alignItems: 'center'}}>
    <RectShape className="textBlockPlaceholder" color='#f0f0f0' style={{width: 200, height: 80}} />
    <TextBlock className="textBlockPlaceholder marginRight10px" rows={5} color={'#f0f0f0'} />
    <RectShape className="textBlockPlaceholder" color='#f0f0f0' style={{width: 200, height: 80}} />
    <TextBlock className="textBlockPlaceholder marginRight10px" rows={5} color={'#f0f0f0'} />
    <RectShape className="textBlockPlaceholder" color='#f0f0f0' style={{width: 200, height: 80}} />
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
</div>;




// WEBPACK FOOTER //
// ./src/containers/templates/builder/sections/tab_dnd/SectionPlaceholder.jsx